// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"CatalogBookCard_cardTitle__YCJ6Y","card":"CatalogBookCard_card__UTAjz","cardBody":"CatalogBookCard_cardBody__RRy8m","cardImage":"CatalogBookCard_cardImage__NzqVQ"};